import { render, staticRenderFns } from "./ObjectSnippet.vue?vue&type=template&id=33df44d1&"
import script from "./ObjectSnippet.vue?vue&type=script&lang=js&"
export * from "./ObjectSnippet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports